import React from 'react';
import {Col, Row, Select} from 'antd';
import {FAQ_PAGE, INDEX_PAGE} from '../../configuration/paths';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import TranslatedText from '../TranslatedText';
import {connect} from 'react-redux';
import {makeAction} from '../../redux/actions/makeAction';
import {OPEN_MODAL} from '../../redux/actions/actionTypes';
import PropTypes from 'prop-types';

const Footer = ({openModal}) => {
  const {i18n} = useTranslation();
  return (
    <div className="container">
      <Row>
        <Col xs={24} xl={6} className="goto-footer">
          <h3 className="sectionTitle"><TranslatedText transKey="footer.links.goto"/></h3>
          <ul>
            <li>
              <Link to={INDEX_PAGE}>
                <TranslatedText transKey="navigation.pages.home"/>
              </Link>
            </li>
            <li>
              <Link to={FAQ_PAGE}>
                <TranslatedText transKey="navigation.pages.faq"/>
              </Link>
            </li>
          </ul>
        </Col>
        <Col className="about-footer" xs={24} xl={6}>
          <h3 className="sectionTitle"><TranslatedText transKey="footer.about.title"/></h3>
          <ul>
            <li><Link to={{pathname: INDEX_PAGE, hash: 'about'}}><TranslatedText transKey="footer.about.about"/></Link></li>
            <li><Link to={{pathname: INDEX_PAGE, hash: 'why'}}><TranslatedText transKey="footer.about.why"/></Link></li>
          </ul>
        </Col>
        <Col xs={24} xl={8} className="faq-footer">
          <h3 className="sectionTitle"><TranslatedText transKey="footer.faq.faq"/></h3>
          <ul>
            <li>
              <Link to={{pathname: FAQ_PAGE, hash: 'item1', state: {active: 'item1'}}}>
                <TranslatedText transKey="faq.item1.question"/>
              </Link>
            </li>
            <li>
              <Link to={{pathname: FAQ_PAGE, hash: 'item2', state: {active: 'item2'}}}>
                <TranslatedText transKey="faq.item2.question"/>
              </Link>
            </li>
            <li className="readmore">
              <Link to={FAQ_PAGE}>
                <TranslatedText transKey="footer.faq.readmore"/>
              </Link>
            </li>
          </ul>
        </Col>
        <Col className="support-footer" xs={24} xl={4}>
          <h3 className="sectionTitle"><TranslatedText transKey="footer.support.needhelp"/></h3>
          <p>
            <span><TranslatedText transKey="footer.support.mail"/></span>
          </p>
          <Select dropdownClassName="language-select-dropdown" className="language-select" defaultValue="en" onChange={value => i18n.changeLanguage(value)}>
            <Select.Option value="en" className={i18n.language === 'en' ? 'active' : ''}>
              <TranslatedText transKey="footer.language.english"/>
            </Select.Option>
            <Select.Option value="zh" className={i18n.language === 'zh' ? 'active' : ''}>
              <TranslatedText transKey="footer.language.chinese"/>
            </Select.Option>
	    <Select.Option value="ko"><TranslatedText transKey="footer.language.korean"/></Select.Option>
	    <Select.Option value="ja"><TranslatedText transKey="footer.language.japanese"/></Select.Option>
	    <Select.Option value="es"><TranslatedText transKey="footer.language.spanish"/></Select.Option>
	    <Select.Option value="vi"><TranslatedText transKey="footer.language.vietnamese"/></Select.Option>
          </Select>
          <p className="copyright-notice">
            <span><TranslatedText transKey="footer.support.copyright"/></span>
          </p>
        </Col>
      </Row>
    </div>
  );
};

Footer.propTypes = {
  openModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  openModal: makeAction(OPEN_MODAL),
};

export default connect(
  null,
  mapDispatchToProps,
)(React.memo(Footer));



// WEBPACK FOOTER //
// /src/components/navigation/Footer.jsx